import { __decorate } from "tslib";
import { injectable } from '@/inversify.config';
import { proxy, subscribe } from '@/infrastructure/object-reactive/object-reactive';
let UserGuideModelImpl = class UserGuideModelImpl {
    constructor() {
        this._userGuide = proxy(null);
    }
    get userGuide() {
        return this._userGuide.value;
    }
    updateUserGuide(userGuide) {
        this._userGuide.value = {
            ...this._userGuide.value,
            ...userGuide,
        };
    }
    subscribeUserGuide(callback) {
        const dispose = subscribe(() => this._userGuide.value, () => callback(this._userGuide.value), {
            immediate: true,
        });
        return dispose;
    }
};
UserGuideModelImpl = __decorate([
    injectable()
], UserGuideModelImpl);
export { UserGuideModelImpl };
